import { IconChevronsLeft } from '@tabler/icons-react';
import { Button } from '@components/ui/Button';
import { useTranslation } from 'react-i18next';

interface ArsenalBackProps {
  bg: string;
  onClick: () => void;
}

export function ArsenalBack({ bg, onClick }: ArsenalBackProps) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Arsenal' });

  return (
    <Button className="btn border-0 border-b border-secondary relative h-16" onClick={onClick}>
      <div className="absolute inset-0 overflow-hidden">
        <img
          className="absolute inset-0 w-full h-full object-cover"
          src={`/img/backgrounds/${bg}`}
          alt="Go back"
        />
      </div>
      <div className="absolute inset-0 grid-overlay" />
      <div className="absolute inset-0 bg-linear-to-r from-black to-black/50" />

      <div className="absolute inset-0 flex p-2 items-center">
        <IconChevronsLeft />
        <p className="text-white text-lg font-bold ml-2">{t('back')}</p>
      </div>
    </Button>
  );
}